
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiTwowayAnalog75 as ObiTwowayAnalog75Element} from '@oicl/openbridge-webcomponents/dist/icons/icon-twoway-analog-75.js';
 
 
 

 
 export const ObiTwowayAnalog75 = createComponent({
   react: React,
   tagName: 'obi-twoway-analog-75',
   elementClass: ObiTwowayAnalog75Element,
   events: {
     
   }
  });
 
 